module.exports = __webpack_public_path__ + "static/media/Logo Shree Jeen Interiors.9b430086.svg";